import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CanDeactivateGuard
    , ConditionType
    , FormType
    , ModalSize
    , RefreshType
    , RequestType
    // , DetailHandlingMode
 } from "yt-ng-framework";
import { ColumnType, CryptoService, PrintType, TableRowColorType } from 'yt-ng-framework';
import { LookupsRoutes } from "../lookups/routes";
import { HomeComponent } from "./home/home.component";
import { EOtpremnicaTabsComponent } from "./eotpremnica/eotpremnica-tabs.component";
import { EOtpremnica } from "./eotpremnica/eotpremnica";
import { EOtpremnicaView } from "./eotpremnica/eotpremnica-view";
import { EOtpremnicaStavka } from "./eotpremnica/eotpremnica-stavka";
import { EOtpremnicaStavkaView } from "./eotpremnica/eotpremnica-stavka-view";
import { EOtpremnicaComponent } from "./eotpremnice.component";
import { NacinOtpreme } from "./nacin-otpreme/nacin-otpreme";
import { NacinOtpremeComponent } from "./nacin-otpreme/nacin-otpreme.component";
import { TipOtpremniceComponent } from "./tip-otpremnice/tip-otpremnice.component";
import { TipOtpremnice } from "./tip-otpremnice/tip-otpremnice";
import { EOtpremnicaStavkaModalUpdateComponent } from "./eotpremnica/eotpremnica-stavka-modal-update.component";
import { EPrijemnicaTabsComponent } from "./eprijemnica/eprijemnica-tabs.component";
import { EPrijemnica } from "./eprijemnica/eprijemnica";
import { EPrijemnicaView } from "./eprijemnica/eprijemnica-view";
import { EPrijemnicaStavka } from "./eprijemnica/eprijemnica-stavka";
import { EPrijemnicaStavkaView } from "./eprijemnica/eprijemnica-stavka-view";
import { EOtpremnicaPrevoz } from "./eotpremnica/eotpremnica-prevoz";
import { EOtpremnicaPrevozView } from "./eotpremnica/eotpremnica-prevoz-view";
import { EOtpremnicaStavkaDodatniAtribut } from "./eotpremnica/eotpremnica-stavka-dodatni-atribut";
import { EOtpremnicaOpasnaMaterija } from "./eotpremnica/eotpremnica-opasna-materija";
import { EPrijemnicaPrevoz } from "./eprijemnica/eprijemnica-prevoz";
import { EPrijemnicaPrevozView } from "./eprijemnica/eprijemnica-prevoz-view";
import { EPrijemnicaOpasnaMaterija } from "./eprijemnica/eprijemnica-opasna-materija";
import { EPrijemnicaStavkaDodatniAtribut } from "./eprijemnica/eprijemnica-stavka-dodatni-atribut";
import { SendEdokumentComponent } from "./edokument/send-edokument.component";
import { PocetakVoznjeComponent } from "./edokument/pocetak-voznje.component";
import { PromenaVozilaComponent } from "./edokument/promena-vozila.component";
import { EPrijemnicaStavkaModalUpdateComponent } from "./eprijemnica/eprijemnica-stavka-modal-update.component";




let childrenRoutes: Routes = [
    {
        path: 'home',
        component: HomeComponent
    }
    , {
        path: 'tipotpremnice',
        component: TipOtpremniceComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'tipotpremnice',
                getName: 'get',
                getParameters: [],
                modelClass: TipOtpremnice,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'TIPOTPREMNICE.NAZIV.SINGULAR', visible: true, canHide: false }
                    , { name: 'GenericName', label: 'TIPOTPREMNICE.GENERICNAME.SINGULAR', visible: true, canHide: false }
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'TipOtpremnice',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'TIPOOTPREMNICE.PLURAL'
        }
    } 
    , {
        path: 'nacinotpreme',
        component: NacinOtpremeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'nacinotpreme',
                getName: 'get',
                getParameters: [],
                modelClass: NacinOtpreme,
                parentProperty:'',
                tableColumns: [
                    { name: 'Naziv', label: 'NACINOTPREME.NAZIV.SINGULAR', visible: true, canHide: false }                               
                ],
                sortBy: 'Naziv',
                sortReverse: false,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive
            },
            mainTitle: 'NacinOtpreme',
            updateComponent: null,
            modalSize: ModalSize.Md,
            refreshType: RefreshType.NoReload,
            loadOnInit: true,
            breadcrumbLabel: 'NACINOTPREME.PLURAL'
        }
    }    
    , {
        path: 'izeotpremnica',
        component: EOtpremnicaTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data:{
            mainList:{
                userRightsModelName: 'izeotpremnica',
                printName: 'stampa_izlazne_otpremnice',
                label: 'TABLE.IZEOTPREMNICE.PLURAL',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'EOtpremnica',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/eotpremnice/izeotpremnica' }],
                modelClass: EOtpremnica,
                shortModelClass: EOtpremnicaView,
                parentProperty: '',
                tableColumns: [
                      { name: 'BrojOtpremnice', label: 'EOTPREMNICA.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'EOTPREMNICA.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'EOTPREMNICA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentMesto', label: 'EOTPREMNICA.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }
                , {
                            name: 'StatusColor'
                            , label: 'EOTPREMNICA.STATUSGENERICNAME.SINGULAR'
                            , type: "color-box"
                            , visible: true
                            , candHide: false
                            , width: '10%'
                            , aligment: 'center' 
                            , tooltipName: 'StatusTooltip'
                            , tooltipName2: 'Komentar'
                        }
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}

                ],

                tableContextMenuItems:[
                     {Name: 'Item 1', Action: 'Ponovi', Label: 'EOTPREMNICA.PONOVI.ACTION' }
                     , { Name: 'Item 2', Action: 'OsveziStatus', Label: 'EOTPREMNICA.OSVEZISTATUS.ACTION' }
                     , { Name: 'Item 3', Action: 'StornoDokument', Label: 'EOTPREMNICA.STORNO.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityStorno, Indicator: "global" }
                     , { Name: 'Item 4', Action: 'PosaljiEOtpremnicu', Label: 'EOTPREMNICA.SEND.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityPosaljiEOtpremnicu }
                     , { Name: 'Item 5', Action: 'PocetakVoznje', Label: 'EOTPREMNICA.POCETAKVOZNJE.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityPocetakVoznje ,Indicator: "global" }
                    // , { Name: 'Item 6', Action: 'PromenaVozila', Label: 'EOTPREMNICA.PROMENAVOZILA.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityPromenaVozila ,Indicator: "global" }

                ],

                sortBy: 'ID',
                sortReverse: true,
                enableEdit: false,
                enableDelete: false,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                // defaultPropertyName: 'BrojOtpremnice',
                detailList: [
                    {
                        userRightsModelName: 'izeotpremnicastavka',
                        // detailHandlingMode: DetailHandlingMode.Collection,
                        modelName: 'EOtpremnicaStavka',
                        getName: 'getByEOtpremnicaID',
                        label: 'TABLE.STAVKEIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaStavka,
                        shortModelClass: EOtpremnicaStavkaView,
                        tableColumns: [
                            { name: 'RedniBroj', label: 'EOTPREMNICASTAVKA.REDNIBROJ.SINGULAR', visible: true, width: '10%' }
                            , {name: 'Sifra', label: 'EOTPREMNICASTAVKA.SIFRA.SINGULAR', visible: true, width: '10%'}
                            , { name: 'Roba', label: 'EOTPREMNICASTAVKA.ROBA.SINGULAR', visible: true, width: '50%' }
                            , { name: 'Kolicina', label: 'EOTPREMNICASTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '30%'}
                            , { name: 'JedinicaMere', label: 'EOTPREMNICASTAVKA.JM.SINGULAR', visible: true, width: '10%'}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaID',
                        updateComponent: EOtpremnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eotpremnice/izeotpremnicastavka',
                    }
                    , {
                        modelName: 'EOtpremnicaPrevoz',
                        getName: 'getByEOtpremnicaID',
                        label: 'TABLE.PREVOZIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaPrevoz,
                        shortModelClass: EOtpremnicaPrevozView,
                        tableColumns: [
                            { name: 'BrojVoznje', label: 'EOTPREMNICAPREVOZ.BROJVOZNJE.SINGULAR', type: 'number', aligment: 'left', visible: true, width: '30%', format: '1.0-0' }
                            , { name: 'PrevoznikNaziv', label: 'EOTPREMNICAPREVOZ.PREVOZNIKNAZIV.SINGULAR', canHide: false, width: '30%' }
                            , { name: 'PocetnaLokacijaPrevoznika', label: 'EOTPREMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }
                            , { name: 'PretovarnaTackaPrevoznika', label: 'EOTPREMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaID',
                        updateComponent: EOtpremnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eotpremnice/izeotpremnicaprevoz',
                    }
                    , {
                        modelName: 'EOtpremnicaOpasnaMaterija',
                        getName: 'getByEOtpremnicaID',
                        label: 'TABLE.OPASNAMATERIJAIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaOpasnaMaterija,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICA.OPASNAMATERIJA.NAZIV.SINGULAR'}
                            , { name: 'Vrednost', label: 'EOTPREMNICA.OPASNAMATERIJA.VREDNOST.SINGULAR'}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaID',
                        updateComponent: EOtpremnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eotpremnice/izeotpremnicaopasnamaterija',
                    }
                    , {
                        userRightsModelName: 'izeotpremnicastavkadodatniatribut',
                        modelName: 'EOtpremnicaStavkaDodatniAtribut',
                        getName: 'getByEOtpremnicaStavkaID',
                        label: 'TABLE.DODATNIATRIBUTISTAVKEIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaStavkaDodatniAtribut,
                        // shortModelClass: EOtpremnicaStavkaView,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICASTAVKADODATNIATRIBUT.NAZIV.SINGULAR', visible: true, width: '70%' }
                            , { name: 'Vrednost'
                                , label: 'EOTPREMNICASTAVKADODATNIATRIBUT.VREDNOST.SINGULAR'
                                , visible: true
                                , type: 'text'
                            }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: true,
                        parentProperty: 'EOtpremnicaStavkaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: false,
                        formControlDataName: 'eotpremnice/izeotpremnicastavkadodatniatribut',
                    }
                ],

                formControlDataName: 'eotpremnice/izeotpremnica',
                requestType: RequestType.POST

            },
            mainTitle: 'Izlazna otpremnica',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'IZEOTPREMNICE.PLURAL'
        }
    }
    , {
        path: 'uleotpremnica',
        component: EOtpremnicaTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data:{
            mainList:{
                userRightsModelName: 'uleotpremnica',
                label: 'TABLE.ULEOTPREMNICE.PLURAL',
                //printName: 'stampa_ulazne_otpremnice',
                printName: 'stampa_izlazne_otpremnice',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'EOtpremnica',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/eotpremnice/uleotpremnica' }],
                modelClass: EOtpremnica,
                shortModelClass: EOtpremnicaView,
                parentProperty: '',

                
                tableColumns: [
                      { name: 'BrojOtpremnice', label: 'EOTPREMNICA.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'EOTPREMNICA.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentPosiljalac', label: 'EOTPREMNICA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentPosiljalacMesto', label: 'EOTPREMNICA.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }                
                    , { name: 'BrojUlazneOtpremnice', label: 'EOTPREMNICA.BROJOTPREMNICEPOSILJAOCA.SINGULAR', visible: true, width: '17%', canHide: true }
                    , { name: 'BrojIzlaznePrijemnice', label: 'EOTPREMNICA.BROJIZLAZNEPRIJEMNICE.SINGULAR', visible: true, width: '17%', canHide: true }

                    , {
                            name: 'StatusColor'
                            , label: 'EOTPREMNICA.STATUSGENERICNAME.SINGULAR'
                            , type: "color-box"
                            , visible: true
                            , candHide: false
                            , width: '10%'
                            , aligment: 'center' 
                            , tooltipName: 'StatusTooltip'
                            , tooltipName2: 'Komentar'
                        }
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}

                ],

                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'OsveziStatus', Label: 'EOTPREMNICA.OSVEZISTATUS.ACTION' }
                    , { Name: 'Item 2', Action: 'FizickiPrijem', Label: 'EOTPREMNICA.FIZICKIPRIJEM.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityFizickiPrijem, Indicator: "global" }
                    , { Name: 'Item 3', Action: 'KreirajPrijemnicu', Label: 'EOTPREMNICA.KREIRAJPRIJEMNICU.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityKreirajPrijemnicu, Indicator: "global" }
                ],

                sortBy: 'ID',
                sortReverse: true,
                enableEdit: false,
                enableDelete: false,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,

                detailList: [
                    {
                        userRightsModelName: 'uleotpremnicastavka',
                        modelName: 'EOtpremnicaStavka',
                        getName: 'getByEOtpremnicaID',
                        label: 'TABLE.STAVKEULEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaStavka,
                        shortModelClass: EOtpremnicaStavkaView,
                        tableColumns: [
                            { name: 'RedniBroj', label: 'EOTPREMNICASTAVKA.REDNIBROJ.SINGULAR', visible: true, width: '10%' }
                            , { name: 'Roba', label: 'EOTPREMNICASTAVKA.ROBA.SINGULAR', visible: true, width: '30%' }
                            , { name: 'Kolicina', label: 'EOTPREMNICASTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true }
                            , { name: 'JedinicaMere', label: 'EOTPREMNICASTAVKA.JM.SINGULAR', visible: true}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaID',
                        updateComponent: EOtpremnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eotpremnice/uleotpremnicastavka',
                    }
                    , {
                        modelName: 'EOtpremnicaPrevoz',
                        getName: 'getByEOtpremnicaID',
                        label: 'TABLE.PREVOZIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaPrevoz,
                        shortModelClass: EOtpremnicaPrevozView,
                        tableColumns: [
                            // { name: 'BrojVoznje', label: 'EOTPREMNICAPREVOZ.BROJVOZNJE.SINGULAR', type: 'number', aligment: 'right', visible: true, width: '30%' }
                            // , { name: 'PocetnaLokacijaPrevoznika', label: 'EOTPREMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR', canHide: true }
                            // , { name: 'PretovarnaTackaPrevoznika', label: 'EOTPREMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR', canHide: true }
                             { name: 'BrojVoznje', label: 'EOTPREMNICAPREVOZ.BROJVOZNJE.SINGULAR', type: 'number', aligment: 'left', visible: true, width: '30%', format: '1.0-0' }
                            , { name: 'PrevoznikNaziv', label: 'EOTPREMNICAPREVOZ.PREVOZNIKNAZIV.SINGULAR', canHide: false, width: '30%' }
                            , { name: 'PocetnaLokacijaPrevoznika', label: 'EOTPREMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }
                            , { name: 'PretovarnaTackaPrevoznika', label: 'EOTPREMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }    
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaID',
                        updateComponent: EOtpremnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eotpremnice/uleotpremnicaprevoz',
                    }
                    , {
                        userRightsModelName: 'uleotpremnicaopasnamaterija',
                        modelName: 'EOtpremnicaOpasnaMaterija',
                        getName: 'getByEOtpremnicaID',
                        label: 'TABLE.OPASNAMATERIJAIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaOpasnaMaterija,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICA.OPASNAMATERIJA.NAZIV.SINGULAR'}
                            , { name: 'Vrednost', label: 'EOTPREMNICA.OPASNAMATERIJA.VREDNOST.SINGULAR'}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaID',
                        updateComponent: EOtpremnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eotpremnice/uleotpremnicaopasnamaterija',
                    }
                    , {
                        modelName: 'EOtpremnicaStavkaDodatniAtribut',
                        getName: 'getByEOtpremnicaStavkaID',
                        label: 'TABLE.DODATNIATRIBUTISTAVKEIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaStavkaDodatniAtribut,
                        // shortModelClass: EOtpremnicaStavkaView,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICASTAVKADODATNIATRIBUT.NAZIV.SINGULAR', visible: true, width: '70%' }
                            , { name: 'Vrednost'
                                , label: 'EOTPREMNICASTAVKADODATNIATRIBUT.VREDNOST.SINGULAR'
                                , visible: true
                                , type: 'text'
                            }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaStavkaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: false,
                        formControlDataName: 'eotpremnice/uleotpremnicastavkadodatniatribut',
                    }                                   
                ],

                formControlDataName: 'eotpremnice/uleotpremnica',
                requestType: RequestType.POST
            },
            mainTitle: 'Ulazna otpremnica',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'ULEOTPREMNICE.PLURAL'
        }
    }
    , {
        path: 'uleprijemnica',
        component: EPrijemnicaTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data:{
            mainList:{
                userRightsModelName: 'uleprijemnica',
                label: 'TABLE.ULEPRIJEMNICE.PLURAL',
//                printName: 'stampa_ulazne_prijemnice',
                printName: 'stampa_izlazne_prijemnice',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'EPrijemnica',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/eotpremnice/uleprijemnica' }],
                modelClass: EPrijemnica,
                shortModelClass: EPrijemnicaView,
                parentProperty: '',
                tableColumns: [
                      { name: 'BrojPrijemnice', label: 'EPRIJEMNICA.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'EPRIJEMNICA.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentPosiljalac', label: 'EPRIJEMNICA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentPosiljalacMesto', label: 'EPRIJEMNICA.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }
                    , { name: 'BrojUlaznePrijemnice', label: 'EPRIJEMNICA.BROJPRIJEMNICEPRIMAOCA.SINGULAR', visible: true, width: '17%', canHide: true }
                    , {
                                name: 'StatusColor'
                                , label: 'EPRIJEMNICA.STATUSGENERICNAME.SINGULAR'
                                , type: "color-box"
                                , visible: true
                                , candHide: false
                                , width: '10%'
                                , aligment: 'center' 
                                , tooltipName: 'StatusTooltip'
                                , tooltipName2: 'Komentar'
                            }
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}

                ],

                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'OsveziStatus', Label: 'EPRIJEMNICA.OSVEZISTATUS.ACTION' }
                    ,{ Name: 'Item 2', Action: 'PrihvatiPrijemnicu', Label: 'EPRIJEMNICA.PRIHVATIPRIJEMNICU.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityPrihvatiPrijemnicu,Indicator: "global" }
                    ,{ Name: 'Item 3', Action: 'OdbijPrijemnicu', Label: 'EPRIJEMNICA.ODBIJPRIJEMNICU.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityOdbijPrijemnicu, Indicator: "global"}
                ],

                sortBy: 'ID',
                sortReverse: true,
                enableEdit: false,
                enableDelete: false,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,

                detailList: [
                    {
                        userRightsModelName: 'uleprijemnicastavka',
                        modelName: 'EPrijemnicaStavka',
                        getName: 'getByEPrijemnicaID',
                        label: 'TABLE.STAVKEULEPRIJEMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaStavka,
                        shortModelClass: EPrijemnicaStavkaView,
                        tableColumns: [
                            { name: 'RedniBroj', label: 'EOTPREMNICASTAVKA.REDNIBROJ.SINGULAR', visible: true, width: '10%' }                            
                            , { name: 'Roba', label: 'EPRIJEMNICASTAVKA.NAZIV.SINGULAR', visible: true, width: '30%' }
                            , { name: 'Kolicina', label: 'EPRIJEMNICASTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true }
                            , { name: 'PristiglaKolicina', label: 'EPRIJEMNICASTAVKA.PRISTIGLAKOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true }
                            , { name: 'PrimljenaKolicina', label: 'EPRIJEMNICASTAVKA.PRIMLJENAKOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true }
                            , { name: 'JedinicaMere', label: 'EPRIJEMNICASTAVKA.JM.SINGULAR', visible: true}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaID',
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eprijemnice/uleprijemnicastavka',
                  }
                    , {
                        userRightsModelName: 'uleprijemnicaprevoz',
                        modelName: 'EPrijemnicaPrevoz',
                        getName: 'getByEPrijemnicaID',
                        label: 'TABLE.PREVOZIZEPRIJEMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaPrevoz,
                        shortModelClass: EPrijemnicaPrevozView,
                        tableColumns: [
                            // { name: 'BrojVoznje', label: 'EPRIJEMNICA.PREVOZ.BROJVOZNJE.SINGULAR', type: 'number', aligment: 'right', visible: true, width: '30%' }
                            // , { name: 'PocetnaLokacijaPrevoznika', label: 'EPRIJEMNICA.PREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR', canHide: true }
                            // , { name: 'PretovarnaTackaPrevoznika', label: 'EPRIJEMNICA.PREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR', canHide: true }
                             { name: 'BrojVoznje', label: 'EPRIJEMNICA.PREVOZ.BROJVOZNJE.SINGULAR', type: 'number', aligment: 'left', visible: true, width: '30%', format: '1.0-0' }
                            , { name: 'PrevoznikNaziv', label: 'EPRIJEMNICA.PREVOZ.PREVOZNIKNAZIV.SINGULAR', canHide: false, width: '30%' }
                            , { name: 'PocetnaLokacijaPrevoznika', label: 'EPRIJEMNICA.PREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }
                            , { name: 'PretovarnaTackaPrevoznika', label: 'EPRIJEMNICA.PREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }

                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eprijemnice/uleprijemnicaprevoz',
                    }
                    , {
                        userRightsModelName: 'uleprijemnicaopasnamaterija',
                        modelName: 'EPrijemnicaOpasnaMaterija',
                        getName: 'getByEPrijemnicaID',
                        label: 'TABLE.OPASNAMATERIJAIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaOpasnaMaterija,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICA.OPASNAMATERIJA.NAZIV.SINGULAR'}
                            , { name: 'Vrednost', label: 'EOTPREMNICA.OPASNAMATERIJA.VREDNOST.SINGULAR'}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eprijemnice/uleprijemnicaopasnamaterija',
                    }
                    , {
                        userRightsModelName: 'uleprijemnicastavkadodatniatribut',
                        modelName: 'EPrijemnicaStavkaDodatniAtribut',
                        getName: 'getByEPrijemnicaStavkaID',
                        label: 'TABLE.DODATNIATRIBUTISTAVKEIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaStavkaDodatniAtribut,
                        // shortModelClass: EPrijemnicaStavkaView,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICASTAVKADODATNIATRIBUT.NAZIV.SINGULAR', visible: true, width: '70%' }
                            , { name: 'Vrednost'
                                , label: 'EOTPREMNICASTAVKADODATNIATRIBUT.VREDNOST.SINGULAR'
                                , visible: true
                                , type: 'text'
                            }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaStavkaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: false,
                        formControlDataName: 'eprijemnice/uleprijemnicastavkadodatniatribut',
                    }                 
                ],
                formControlDataName: 'eprijemnice/uleprijemnica',
                requestType: RequestType.POST

            },
            mainTitle: 'Ulazna prijemnica',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'ULEPRIJEMNICE.PLURAL'
        }
    }
    , {
            path: 'send-eotpremnica',
            component: SendEdokumentComponent,
            pathMatch: 'full',
            data: {
                mainList: {
                    modelName: 'fakdokument',
                    getName: 'getDokumenteByFakDokumentID',
                    getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                    parentProperty: '',
                    tableColumns: [
                        { name: 'fileName', label: 'EDOKUMENT.ATTACHMENT.DOCUMENTNAME', visible: true, canHide: false }
                        
                    ],
                    tableRowColors: [],
                    sortBy: '',
                    sortReverse: true,
                    enableEdit: true,
                    enableDelete: true,
                    formType: FormType.Reactive,
                    printName: 'printaj',
                    defaultPropertyName: ''                
                },
                mainTitle: 'SLANJE E-DOKUMENATA',
                modalSize: ModalSize.Lg,
                refreshType: RefreshType.Reload,
                loadOnInit: true,
                breadcrumbLabel: 'SENDEDOKUMENT.PLURAL',
                updateComponent: SendEdokumentComponent
            }
        }

    , {
        path: 'izeprijemnica',
        component: EPrijemnicaTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data:{
            mainList:{
                userRightsModelName: 'izeprijemnica',
                printName: 'stampa_izlazne_prijemnice',
                label: 'TABLE.IZEPRIJEMNICE.PLURAL',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'EPrijemnica',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/eotpremnice/izeprijemnica' }],
                modelClass: EPrijemnica,
                shortModelClass: EPrijemnicaView,
                parentProperty: '',
                tableColumns: [
                      { name: 'BrojPrijemnice', label: 'EPRIJEMNICA.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'EPRIJEMNICA.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'EPRIJEMNICA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentMesto', label: 'EPRIJEMNICA.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }
                    ,{ name: 'BrojUlazneOtpremnice', label: 'EPRIJEMNICA.BROJULAZNEOTPREMNICE.SINGULAR', visible: true, width: '17%', canHide: true}
                    , {
                            name: 'StatusColor'
                            , label: 'EPRIJEMNICA.STATUSGENERICNAME.SINGULAR'
                            , type: "color-box"
                            , visible: true
                            , candHide: false
                            , width: '10%'
                            , aligment: 'center' 
                            , tooltipName: 'StatusTooltip'
                            , tooltipName2: 'Komentar'
                        }
                        
                    ,{ name: 'StatusGenericName', label: '', visible: false, width: '0%'}

                ],

                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'OsveziStatus', Label: 'EPRIJEMNICA.OSVEZISTATUS.ACTION' }
                    , { Name: 'Item 2', Action: 'PosaljiEPrijemnicu', Label: 'EPRIJEMNICA.SEND.ACTION', IsEnabledFunction: CheckContextMenuAvailabilityPosaljiPrijemnicu  }

                ],

                sortBy: 'ID',
                sortReverse: true,
                enableEdit: false,
                enableDelete: false,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,
                // defaultPropertyName: 'BrojPrijemnice',

                detailList: [
                    {
                        userRightsModelName: 'izeprijemnicastavka',
                        modelName: 'EPrijemnicaStavka',
                        getName: 'getByEPrijemnicaID',
                        label: 'TABLE.STAVKEIZEPRIJEMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaStavka,
                        shortModelClass: EPrijemnicaStavkaView,
                        tableColumns: [
                            { name: 'RedniBroj', label: 'EOTPREMNICASTAVKA.REDNIBROJ.SINGULAR', visible: true, width: '10%' }
                            ,{ name: 'Roba', label: 'EPRIJEMNICASTAVKA.ROBA.SINGULAR', visible: true, width: '20%' }
                            , { name: 'JedinicaMere', label: 'EPRIJEMNICASTAVKA.JM.SINGULAR', visible: true, width: '10%' }
                            , { name: 'Kolicina', label: 'EPRIJEMNICASTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '15%'  }
                            , { name: 'PristiglaKolicina', label: 'EPRIJEMNICASTAVKA.PRISTIGLAKOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '15%' }
                            , { name: 'PrimljenaKolicina', label: 'EPRIJEMNICASTAVKA.PRIMLJENAKOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '15%' }
                            , { name: 'VracenaKolicina', label: 'EPRIJEMNICASTAVKA.VRACENAKOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true, width: '15%' }

                            
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaID',
                        updateComponent: EPrijemnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eprijemnice/izeprijemnicastavka',
                    }
                    , {
                        userRightsModelName: 'izeprijemnicaprevoz',
                        modelName: 'EPrijemnicaPrevoz',
                        getName: 'getByEPrijemnicaID',
                        label: 'TABLE.PREVOZIZEPRIJEMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaPrevoz,
                        shortModelClass: EPrijemnicaPrevozView,
                        tableColumns: [
                            // { name: 'BrojVoznje', label: 'EPRIJEMNICA.PREVOZ.BROJVOZNJE.SINGULAR', type: 'number', aligment: 'right', visible: true, width: '30%' }
                            // , { name: 'PocetnaLokacijaPrevoznika', label: 'EPRIJEMNICA.PREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR', canHide: true }
                            // , { name: 'PretovarnaTackaPrevoznika', label: 'EPRIJEMNICA.PREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR', canHide: true }
                            { name: 'BrojVoznje', label: 'EPRIJEMNICAPREVOZ.BROJVOZNJE.SINGULAR', type: 'number', aligment: 'left', visible: true, width: '30%', format: '1.0-0' }
                            , { name: 'PrevoznikNaziv', label: 'EPRIJEMNICAPREVOZ.PREVOZNIKNAZIV.SINGULAR', canHide: false, width: '30%' }
                            , { name: 'PocetnaLokacijaPrevoznika', label: 'EPRIJEMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }
                            , { name: 'PretovarnaTackaPrevoznika', label: 'EPRIJEMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.SINGULAR', canHide: false, width: '20%'  }

                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eprijemnice/izeprijemnicaprevoz',
                    }
                    , {
                        userRightsModelName: 'izeprijemnicaopasnamaterija',
                        modelName: 'EPrijemnicaOpasnaMaterija',
                        getName: 'getByEPrijemnicaID',
                        label: 'TABLE.OPASNAMATERIJAIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaOpasnaMaterija,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICA.OPASNAMATERIJA.NAZIV.SINGULAR'}
                            , { name: 'Vrednost', label: 'EOTPREMNICA.OPASNAMATERIJA.VREDNOST.SINGULAR'}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eprijemnice/izeprijemnicaopasnamaterija',
                    }
                    , {
                        userRightsModelName: 'izeprijemnicastavkadodatniatribut',
                        modelName: 'EPrijemnicaStavkaDodatniAtribut',
                        getName: 'getByEPrijemnicaStavkaID',
                        label: 'TABLE.DODATNIATRIBUTISTAVKEIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EPrijemnicaStavkaDodatniAtribut,
                        // shortModelClass: EPrijemnicaStavkaView,
                        tableColumns: [
                            { name: 'Naziv', label: 'EOTPREMNICASTAVKADODATNIATRIBUT.NAZIV.SINGULAR', visible: true, width: '70%' }
                            , { name: 'Vrednost'
                                , label: 'EOTPREMNICASTAVKADODATNIATRIBUT.VREDNOST.SINGULAR'
                                , visible: true
                                , type: 'text'
                            }
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EPrijemnicaStavkaID',
                        updateComponent: null,
                        formType: 'reactive',
                        showOnFirstPage: false,
                        formControlDataName: 'eprijemnice/izeprijemnicastavkadodatniatribut',
                    }                    
                ],

                formControlDataName: 'eprijemnice/izeprijemnica',
                requestType: RequestType.POST

            },
            mainTitle: 'Izlazna prijemnica',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'IZEPRIJEMNICE.PLURAL'
        }
    }
    , {
        path: 'eotpremnica',
        component: EOtpremnicaTabsComponent,
        pathMatch: 'full',
        canDeactivate: [CanDeactivateGuard],
        data:{
            mainList:{
                userRightsModelName: 'izeotpremnica',
                printName: 'stampa_izlazne_otpremnice',
                label: 'TABLE.IZEOTPREMNICE.PLURAL',
                printType: PrintType.Document,
                printController: 'Report',
                modelName: 'EOtpremnica',
                getName: 'getByUrl',
                getParameters: [{ Name: 'url', Value: '/eotpremnice/izeotpremnica' }],
                modelClass: EOtpremnica,
                shortModelClass: EOtpremnicaView,
                parentProperty: '',
                tableColumns: [
                      { name: 'BrojDokumenta', label: 'EOTPREMNICA.BRDOK.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'Datum', label: 'EOTPREMNICA.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '17%' }
                    , { name: 'Komitent', label: 'EOTPREMNICA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '17%' }
                    , { name: 'KomitentMesto', label: 'EOTPREMNICA.KOMITENTMESTO.SINGULAR', visible: true, width: '17%', canHide: true }
                ],

                tableContextMenuItems:[
                    { Name: 'Item 1', Action: 'OsveziStatus', Label: 'ULAZNIDOKUMENTDOBAVLJACA.OSVEZISTATUS.ACTION' }
                    , { Name: 'Item 2', Action: 'PosaljiEOtpremnicu', Label: 'ULAZNIDOKUMENTDOBAVLJACA.POSALJI.ACTION' }
                    , { Name: 'Item 3', Action: 'PocetakVoznje', Label: 'ULAZNIDOKUMENTDOBAVLJACA.POCETAKVOZNJE.ACTION', Indicator: "global" }
                    , { Name: 'Item 4', Action: 'StornoDokument', Label: 'ULAZNIDOKUMENTDOBAVLJACA.STORNO.ACTION', Indicator: "global" }
                    , { Name: 'Item 5', Action: 'Ponovi', Label: 'ULAZNIDOKUMENTDOBAVLJACA.PONOVI.ACTION' }
                ],

                sortBy: 'ID',
                sortReverse: true,
                enableEdit: false,
                enableDelete: false,
                enablePrint: true,
                enablePrintAccountSelection:true,
                formType: 'reactive',
                closeAfterSave: false,

                detailList: [
                    {
                        modelName: 'EOtpremnicaStavka',
                        getName: 'getByEOtpremnicaID',
                        label: 'TABLE.STAVKEIZEOTPREMNICE.PLURAL',
                        getParameters: [],
                        modelClass: EOtpremnicaStavka,
                        shortModelClass: EOtpremnicaStavkaView,
                        tableColumns: [
                            { name: 'Roba', label: 'EOTPREMNICASTAVKA.ROBA.SINGULAR', visible: true, width: '30%' }
                            , { name: 'Kolicina', label: 'EOTPREMNICASTAVKA.KOLICINA.SINGULAR', type: 'number', aligment: 'right', canHide: true }
                            , { name: 'JedinicaMere', label: 'EOTPREMNICASTAVKA.JM.SINGULAR', visible: true}
                        ],
                        sortBy: 'ID',
                        sortReverse: false,
                        enableEdit: false,
                        enableDelete: false,
                        parentProperty: 'EOtpremnicaID',
                        updateComponent: EOtpremnicaStavkaModalUpdateComponent,
                        formType: 'reactive',
                        showOnFirstPage: true,
                        formControlDataName: 'eotpremnice/izeotpremnicastavka',
                    }
                ],

                formControlDataName: 'eotpremnice/izeotpremnica',
                requestType: RequestType.POST

            },
            mainTitle: 'Izlazna otpremnica',
            updateComponent: null,
            refreshType: RefreshType.NoReload,
            loadOnInit: false,            
            breadcrumbLabel: 'IZEOTPREMNICE.PLURAL'
        }
    },
    {
        path: 'pocetak-voznje',
        component: PocetakVoznjeComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                parentProperty: '',
                tableColumns: [
                    { name: 'fileName', label: 'EDOKUMENT.ATTACHMENT.DOCUMENTNAME', visible: true, candHide: false}
                ],
                tableRowColors: [],
                sortBy: '',
                sortRevers: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: ''
            },
            mainTitle: 'POCETAK VOZNJE',
            ModalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'POCETAKVOZNJE.PLURAL',
            updateComponent: PocetakVoznjeComponent
        }
    },
    {
        path: 'promena-vozila',
        component: PromenaVozilaComponent,
        pathMatch: 'full',
        data: {
            mainList: {
                modelName: 'fakdokument',
                getName: 'getDokumenteByFakDokumentID',
                getParameters: [{Name: 'fakDokumentID', Value: '-1'}],
                parentProperty: '',
                tableColumns: [
                    //{ name: 'fileName', label: 'EDOKUMENT.ATTACHMENT.DOCUMENTNAME', visible: true, candHide: false}
                ],
                tableRowColors: [],
                sortBy: '',
                sortRevers: true,
                enableEdit: true,
                enableDelete: true,
                formType: FormType.Reactive,
                printName: 'printaj',
                defaultPropertyName: ''
            },
            mainTitle: 'PROMENA VOZILA',
            ModalSize: ModalSize.Lg,
            refreshType: RefreshType.Reload,
            loadOnInit: true,
            breadcrumbLabel: 'PROMENAVOZILA.PLURAL',
            updateComponent: PromenaVozilaComponent
        }
    }


]

childrenRoutes = childrenRoutes.concat(LookupsRoutes);

const routes: Routes = [
    {
        path: '',
        component: EOtpremnicaComponent,
        children: childrenRoutes
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class EOtpremniceRoutingModule{}

export function CheckContextMenuAvailabilityFizickiPrijem(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "Received");
 
}

export function CheckContextMenuAvailabilityKreirajPrijemnicu(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "DeliveryConfirmed");
 
}

export function CheckContextMenuAvailabilityPocetakVoznje(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "Sent");
 
}

export function CheckContextMenuAvailabilityStorno(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "Sent");    
}

export function CheckContextMenuAvailabilityPrihvatiPrijemnicu(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "Received");    
}

export function CheckContextMenuAvailabilityOdbijPrijemnicu(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "Received");    
}

export function CheckContextMenuAvailabilityPosaljiEOtpremnicu(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && item.StatusGenericName == null;    
}

export function CheckContextMenuAvailabilityPosaljiPrijemnicu(item: EPrijemnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == '404' || item.StatusGenericName == null);    
}

export function CheckContextMenuAvailabilityPromenaVozila(item: EOtpremnicaView){
    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4);  
    //    return (item.ProvajderID == 1 || item.ProvajderID == 2 || item.ProvajderID == 3 || item.ProvajderID == 4) && (item.StatusGenericName == "Sent");    
}